import { cn as e } from "../../shared/utils.js";
import { InputGroup as t } from "../../input/input-group.js";
import { useFormControlSize as n } from "../../form-control-size/index.js";
import { forwardRef as r, useId as i } from "react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import { Field as s } from "@base-ui/react/field";
//#region src/date-picker/primitive/time-field.tsx
var c = r(({ description: r, disabled: c, error: l, focus: u, label: d, placeholder: f, required: p, size: m, value: h, className: g, inputClassName: _, labelClassName: v, wrapperClassName: y, ...b }, x) => {
	let S = n(), C = m ?? S ?? "md", w = i(), T = !l && !!r, E = !!l;
	return /* @__PURE__ */ o(s.Root, {
		invalid: !!l,
		className: e("flex flex-col gap-2", y),
		children: [
			d && /* @__PURE__ */ a(s.Label, {
				className: e("text-text-secondary data-[required=true]:after:text-text-error block text-left text-base font-normal data-[required=true]:after:ml-0.5 data-[required=true]:after:content-['*']", v),
				htmlFor: w,
				"data-required": p || void 0,
				children: d
			}),
			/* @__PURE__ */ a(t.Root, {
				className: g,
				size: C,
				children: /* @__PURE__ */ a(t.Input, {
					...b,
					ref: x,
					id: w,
					value: h ?? "",
					className: _,
					disabled: c,
					placeholder: f,
					...u ? { "data-focused": "" } : {}
				})
			}),
			E && /* @__PURE__ */ a("p", {
				className: "text-text-error text-base",
				children: l
			}),
			T && /* @__PURE__ */ a("p", {
				className: "text-text-tertiary text-base",
				children: r
			})
		]
	});
});
c.displayName = "TimeField";
//#endregion
export { c as TimeField };
